import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

import Home from './pages/Home';
import Profile from './pages/Profile';
import Login from './pages/Login';
import Char from './pages/Char';
import NotFound from './pages/NotFound';
import Logout from './pages/Logout';
import Header from './components/Header';
import Onepost from './pages/Onepost';
import Rules from './pages/Rules';
import Notifications from './pages/Notifications';
import Settings from './pages/Settings';
import Update from './pages/Update';
import Search from './pages/Search';
import Messages from './pages/Messages';
import Boost from './pages/Boost';
import Admin from './pages/Admin';
import Company from './pages/Company';
import Disabled from './pages/Disabled';
import VIPSettings from './pages/VIPSettings';

const useSystemTheme = () => {
    const [isDarkMode, setIsDarkMode] = useState(false);

    useEffect(() => {
        const match = window.matchMedia('(prefers-color-scheme: dark)');
        setIsDarkMode(match.matches);

        const listener = (e) => setIsDarkMode(e.matches);
        match.addEventListener('change', listener);

        return () => match.removeEventListener('change', listener);
    }, []);

    return isDarkMode;
};

const App = () => {
    const [isOnline, setIsOnline] = useState(true);
    const [isLoading, setIsLoading] = useState(true);

    const checkServerStatus = () => {
        fetch("https://api.fantasyworldtrpg.cz/echo/serveronline.php")
            .then(async (res) => {
                if (!res.ok) {
                    throw new Error("Failed to fetch status file");
                }
                const text = await res.text();
                const cleanedText = text.trim().toLowerCase();
                if (cleanedText === "online") {
                    setIsOnline(true);
                } else {
                    setIsOnline(false);
                }
            })
            .catch((err) => {
                console.error("Error fetching status:", err);
                setIsOnline(false);
            });
    };

    useEffect(() => {
        checkServerStatus();
        setIsLoading(false);

        const interval = setInterval(() => {
            checkServerStatus();
        }, 30000);

        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        fetch("https://api.fantasyworldtrpg.cz/echo/mention_list.php")
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success') {
                    window.mentionList = data.users.map(u => u.echo_nickname);
                }
            });
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            const uid = localStorage.getItem("echo_user");
            if (!uid) return;

            fetch("https://api.fantasyworldtrpg.cz/echo/online.php", {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ uid })
            });
        }, 30000);

        return () => clearInterval(interval);
    }, []);

    const fwUser = localStorage.getItem('fw_user');
    const echoUser = localStorage.getItem('echo_user');

    const isFwLogged = fwUser && fwUser !== "null" && fwUser !== "undefined";
    const isEchoLogged = echoUser && echoUser !== "null" && echoUser !== "undefined";
    const location = useLocation();
    const darkMode = useSystemTheme();
    console.log(`Dark mode: ${darkMode}`);

    const fwUserLvl = Number(localStorage.getItem('fw_user_lvl') || 0);
    const isAdmin = fwUserLvl > 1;

    if (isLoading) {
        return null;
    }

    if (!isOnline && localStorage.getItem('fw_user') !== "3d08dbbe8e51d3f86a464fe7acb0d5bc") {
        return <Disabled />;
    }

    return (
        <>
            <Header />
            <Routes>
                <Route path="/login" element={!isFwLogged ? <Login /> : <Navigate to={isEchoLogged ? "/" : "/char"} />} />
                <Route path="/char" element={isFwLogged ? <Char /> : <Navigate to={isFwLogged ? "/" : "/login"} />} />
                <Route path="/logout" element={isFwLogged ? <Logout /> : <Navigate to={isFwLogged ? "/" : "/login"} />} />
                <Route path="/" element={isFwLogged && isEchoLogged ? <Home /> : <Navigate to={!isFwLogged ? "/login" : "/char"} />} />
                <Route path="/profile/:id?" element={isFwLogged && isEchoLogged ? <Profile key={location.pathname} /> : <Navigate to={!isFwLogged ? "/login" : "/char"} />} />
                <Route path="/company/:id?" element={isFwLogged && isEchoLogged ? <Company key={location.pathname} /> : <Navigate to={!isFwLogged ? "/login" : "/char"} />} />
                <Route path="/notifications" element={isFwLogged && isEchoLogged ? <Notifications /> : <Navigate to={!isFwLogged ? "/login" : "/char"} />} />
                <Route path="/settings" element={isFwLogged && isEchoLogged ? <Settings /> : <Navigate to={!isFwLogged ? "/login" : "/char"} />} />
                <Route path="/vip" element={isFwLogged && isEchoLogged ? <VIPSettings /> : <Navigate to={!isFwLogged ? "/login" : "/char"} />} />
                <Route path="/post/:id" element={isFwLogged && isEchoLogged ? <Onepost key={location.pathname} /> : <Navigate to={!isFwLogged ? "/login" : "/char"} />} />
                <Route path="/search" element={isFwLogged && isEchoLogged ? <Search /> : <Navigate to={!isFwLogged ? "/login" : "/char"} />} />
                <Route path="/chat/:id?" element={isFwLogged && isEchoLogged ? <Messages /> : <Navigate to={!isFwLogged ? "/login" : "/char"} />} />
                <Route path="/rules" element={<Rules />} />
                <Route path="/updates" element={<Update />} />
                <Route path="/boost" element={isFwLogged && isEchoLogged && isAdmin ? <Boost /> : <Navigate to="/" />} />
                <Route path="/admin" element={isFwLogged && isEchoLogged && isAdmin ? <Admin /> : <Navigate to="/" />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    );
};

export default App;
